import React, { useState } from "react";
import { TagInput } from "rsuite";
import { Uploader } from "rsuite";
import { Button, Upload } from "antd";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { MultiSelect } from "primereact/multiselect";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const specializations = [
  { name: "General Physician", code: "GP" },
  { name: "Cardiologist", code: "CARD" },
  { name: "Dermatologist", code: "DERM" },
  { name: "Neurologist", code: "NEUR" },
  { name: "Orthopedic Surgeon", code: "ORTHO" },
  { name: "Pediatrician", code: "PED" },
  { name: "Psychiatrist", code: "PSY" },
  { name: "Gynecologist", code: "GYN" },
  { name: "Oncologist", code: "ONC" },
  { name: "ENT Specialist", code: "ENT" },
  { name: "Ophthalmologist", code: "OPH" },
  { name: "Dentist", code: "DENT" },
  { name: "Radiologist", code: "RAD" },
  { name: "Anesthesiologist", code: "ANES" },
  { name: "Gastroenterologist", code: "GAST" },
  { name: "Nephrologist", code: "NEPH" },
  { name: "Urologist", code: "URO" },
  { name: "Endocrinologist", code: "ENDO" },
  { name: "Pulmonologist", code: "PULM" },
  { name: "Rheumatologist", code: "RHEU" },
  { name: "Hematologist", code: "HEMA" },
  { name: "Plastic Surgeon", code: "PLAST" },
  { name: "General Surgeon", code: "SURG" },
  // { name: "Neurosurgeon", code: "NEUS" },
  { name: "Cosmetologist", code: "COSM" },
  { name: "Pathologist", code: "PATH" },
  { name: "Sexologist", code: "SEXO" },
  { name: "Allergist/Immunologist", code: "ALLG" },
  { name: "Diabetologist", code: "DIAB" },
  { name: "Laparoscopic Surgeon", code: "LAP" },
  { name: "Internal Medicine Specialist", code: "IMED" },
  { name: "Homeopathic Doctor", code: "HOME" },
  { name: "Ayurvedic Doctor", code: "AYUR" },
  { name: "Unani Practitioner", code: "UNANI" },
  { name: "Occupational Therapist", code: "OT" },
  { name: "Physiotherapist", code: "PHYSIO" },
];

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

function DoctorProfessionalInfo({ formik,isEditMode }) {
  const [selectedSpecializations, setSelectedSpecializations] = useState("");
  const multiselectstyles = `
  .css-yi3mkw {
      height: auto;
    min-height: 1.4375em;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    flex-wrap: nowrap;
  }
    /* Custom style for 24px height */
.multiselect-24px .p-multiselect {
  height: 24px !important;
  padding: 2px 6px;
  font-size: 0.75rem;
  line-height: 1;
}
  .input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  -webkit-text-fill-color: #000;
}

.multiselect-24px .p-multiselect-label {
height: 24px !important;
  padding: 3px 6px;
  font-size: 12px;
  line-height: 1;
  display: flex;
  align-items: center;
  font-family: 'Nunito Sans', sans-serif;
}


.multiselect-24px .p-multiselect-token {
  padding: 1px 4px;
  font-size: 0.7rem;
  margin: 1px 2px;
  
}
  .p-multiselect-panel .p-checkbox-box {
  border: 2px solid #213343 !important;  /* Dark border */
  border-radius: 4px;
  width: 16px;
  height: 16px;
}

/* Optional: dark background on check */
.p-multiselect-panel .p-checkbox-box.p-highlight {
  background: #213343;
  border-color: #213343;
}

/* Checkmark color (tick inside) */
.p-multiselect-panel .p-checkbox-icon {
  color: white;
  font-size: 12px;
}
  `;

  const theme = useTheme();

  return (
    <>
      <style>{multiselectstyles}</style>
      <div className="row">
        <div className="col-12 d-flex flex-column align-items-start">
          <div className="col-12 d-flex">
            <h5
              className="fw-semibold h5-WOeTzEASAL"
              style={{ color: "rgb(43, 81, 147)", marginTop: "1rem" }}
            >
              Professional Details
            </h5>
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Specialization<span className="text-danger">*</span>
            </label>
            <MultiSelect
              name="specialization"
              value={formik.values.specialization}
              onChange={(e) => formik.setFieldValue("specialization", e.value)}
              onBlur={formik.handleBlur}
              options={specializations}
              optionLabel="name"
              optionValue="name"
              placeholder="Select Specializations"
              maxSelectedLabels={3}
              showSelectAll={false}
              disabled={isEditMode}
              className="w-full md:w-20rem multiselect-24px border p-2"
            />
            {formik.touched.specialization && formik.errors.specialization && (
              <div
                style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}
              >
                {formik.errors.specialization}
              </div>
            )}
          </div>

          {/* <div>
            <Select
              labelId="demo-multiple-chip-label"
              id="demo-multiple-chip"
              multiple
              name="specialization"
              className="form-control"
              value={formik.values.specialization}
              onChange={(e) => {
                const { value } = e.target;
                formik.setFieldValue(
                  "specialization",
                  typeof value === "string" ? value.split(",") : value
                );
              }}
              onBlur={formik.handleBlur}
              input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {names.map((name) => (
                <MenuItem
                  key={name}
                  value={name}
                  style={getStyles(name, formik.values.specialization, {
                    typography: {
                      fontWeightMedium: 600,
                      fontWeightRegular: 400,
                    },
                  })}
                >
                  {name}
                </MenuItem>
              ))}
            </Select>
          </div> */}
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Experience<span className="text-danger">*</span>
            </label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter Your Experience"
               autoComplete="off"

              value={formik.values.yearsofexperience}
              name="yearsofexperience"
              min="0"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.yearsofexperience &&
              formik.errors.yearsofexperience && (
                <div
                  style={{ fontSize: "0.8rem", color: "red", marginTop: "3px" }}
                >
                  {formik.errors.yearsofexperience}
                </div>
              )}
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Medical License Number<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter License Number"
              autoComplete="off" 
              value={formik.values.medicallicensenumber}
              name="medicallicensenumber"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.medicallicensenumber &&
              formik.errors.medicallicensenumber && (
                <div style={{ fontSize: "0.8rem", color: "red" }}>
                  {formik.errors.medicallicensenumber}
                </div>
              )}
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Professional Affiliations<span className="text-danger">*</span>
            </label>
            <input
              type="text"
             autoComplete="off"
              className="form-control"
              placeholder="Enter Affiliation Optional"
              value={formik.values.professionalaffiliations}
              name="professionalaffiliations"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.professionalaffiliations &&
              formik.errors.professionalaffiliations && (
                <div style={{ fontSize: "0.8rem", color: "red" }}>
                  {formik.errors.professionalaffiliations}
                </div>
              )}
          </div>
        </div>
      </div>
    </>
  );
}

export default DoctorProfessionalInfo;
